{
  "background": {
    "default": {
      "$type": "color",
      "$description": "Page canvas — the base background behind all content.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.985104,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#fafafa"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Subtly differentiated background for alternating or grouped sections.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.970151,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#f5f5f5"
      }
    }
  },
  "surface": {
    "default": {
      "$type": "color",
      "$description": "Default container surface — cards, panels, and inputs on the page.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          1,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#ffffff"
      }
    },
    "raised": {
      "$type": "color",
      "$description": "Raised surface for higher-elevation layers (menus, popovers, dialogs). Higher elevation reads lighter in dark mode.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          1,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#ffffff"
      }
    },
    "sunken": {
      "$type": "color",
      "$description": "Recessed surface for wells and inset regions.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.970151,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#f5f5f5"
      }
    }
  },
  "text": {
    "default": {
      "$type": "color",
      "$description": "Primary body and heading text.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.175228,
          0.006346,
          236.981786
        ],
        "alpha": 1,
        "hex": "#0e1113"
      }
    },
    "muted": {
      "$type": "color",
      "$description": "Secondary text — supporting copy, captions, metadata.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.426427,
          0.011202,
          232.617199
        ],
        "alpha": 1,
        "hex": "#495054"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Tertiary text — placeholders and disabled labels. The mid-grey reads in both modes.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.645222,
          0.009348,
          225.150438
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    },
    "inverse": {
      "$type": "color",
      "$description": "Text and icons rendered on an action or solid fill.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          1,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#ffffff"
      }
    },
    "link": {
      "$type": "color",
      "$description": "Inline hyperlink text.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.289999,
          0.117296,
          259.841938
        ],
        "alpha": 1,
        "hex": "#002664"
      }
    }
  },
  "border": {
    "default": {
      "$type": "color",
      "$description": "Default border for inputs, cards, and dividers.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.901624,
          0.003538,
          219.535738
        ],
        "alpha": 1,
        "hex": "#dcdfe0"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Low-emphasis border for subtle separation.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.94007,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#ebebeb"
      }
    },
    "strong": {
      "$type": "color",
      "$description": "High-emphasis border for focus and selected states.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.645222,
          0.009348,
          225.150438
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    }
  },
  "action": {
    "default": {
      "$type": "color",
      "$description": "Primary interactive colour — buttons, links, key accents. NSW navy in light, brightened for contrast in dark.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.289999,
          0.117296,
          259.841938
        ],
        "alpha": 1,
        "hex": "#002664"
      }
    },
    "hover": {
      "$type": "color",
      "$description": "Hover and active state for primary actions.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.190403,
          0.080719,
          260.682766
        ],
        "alpha": 1,
        "hex": "#001037"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Tinted background for low-emphasis (ghost) actions.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.981046,
          0.012805,
          221.42319
        ],
        "alpha": 1,
        "hex": "#f0fbff"
      }
    }
  },
  "success": {
    "surface": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — tinted background.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.97135,
          0.019006,
          140.501237
        ],
        "alpha": 1,
        "hex": "#eff9ed"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — readable text on the tint.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.40526,
          0.136911,
          142.712023
        ],
        "alpha": 1,
        "hex": "#005a02"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — border and divider.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.775209,
          0.103098,
          142.532525
        ],
        "alpha": 1,
        "hex": "#8fc78a"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.549041,
          0.184944,
          142.800761
        ],
        "alpha": 1,
        "hex": "#008a07"
      }
    }
  },
  "warning": {
    "surface": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — tinted background.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.971893,
          0.01526,
          48.562489
        ],
        "alpha": 1,
        "hex": "#fff3ed"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — readable text on the tint.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.431173,
          0.130695,
          40.89405
        ],
        "alpha": 1,
        "hex": "#882f03"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — border and divider.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.791422,
          0.092884,
          44.093664
        ],
        "alpha": 1,
        "hex": "#eea88a"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.58333,
          0.169705,
          43.997259
        ],
        "alpha": 1,
        "hex": "#c95000"
      }
    }
  },
  "danger": {
    "surface": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — tinted background.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.966669,
          0.016317,
          22.079707
        ],
        "alpha": 1,
        "hex": "#fff0ef"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — readable text on the tint.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.374388,
          0.145685,
          19.336218
        ],
        "alpha": 1,
        "hex": "#7c061f"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — border and divider.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.75077,
          0.106785,
          18.43901
        ],
        "alpha": 1,
        "hex": "#ea9294"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.501996,
          0.192725,
          18.079135
        ],
        "alpha": 1,
        "hex": "#b81237"
      }
    }
  },
  "info": {
    "surface": {
      "$type": "color",
      "$description": "Info (neutral information) — tinted background.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.947933,
          0.013249,
          262.378766
        ],
        "alpha": 1,
        "hex": "#e9eef7"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Info (neutral information) — readable text on the tint.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.331327,
          0.095363,
          262.195822
        ],
        "alpha": 1,
        "hex": "#193366"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Info (neutral information) — border and divider.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.676764,
          0.068234,
          261.470834
        ],
        "alpha": 1,
        "hex": "#8098c2"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Info (neutral information) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.450622,
          0.123283,
          262.351496
        ],
        "alpha": 1,
        "hex": "#2e5299"
      }
    }
  }
}
